import { render } from "./Bravo.vue?vue&type=template&id=301a6300"
import script from "./Bravo.vue?vue&type=script&lang=js"
export * from "./Bravo.vue?vue&type=script&lang=js"

import "./Bravo.vue?vue&type=style&index=0&id=301a6300&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__